import { Button, Icon, Intent } from "@blueprintjs/core"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection, ILandingSectionDescription, ILandingSectionTitle, LANDING_EDIT_MODE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import updateHistory from "../utils/updateHistory"

/* Protopia Ecosystem component */
export interface ITitleEditorProps {
   section?: ILandingSection
}
const TitleEditor = (props: ITitleEditorProps): JSX.Element => {
    const isEdit: boolean           = useLandingStore((state: ILandingStore) => state.isEdit ) 
    const editMode                  = useLandingConsoleStore((state:ILandingConsoleStore) => state.editMode)
    const currentLanding: ILanding  = useLandingStore((state: ILandingStore) => state.currentLanding )

    const onDelete = () => {
        const historyStep: IHistoryStep = {
            data: null,
            prevData: null,
            type: HISTORY_TYPE.SECTION,
            title : "Delete Section's Title and Description",
        } 
        const landing: ILanding = {
            ...currentLanding,
            sections: currentLanding.sections.map(section => {
                if(props.section?.id === section.id) {
                    historyStep.prevData = {...section}
                    section.title = {} as ILandingSectionTitle
                    section.description = {} as ILandingSectionDescription
                    historyStep.data = { ...section }
                    return section  
                }
                return section
            })
        }
        updateHistory( historyStep, landing )     
    }
    
    return isEdit 
            ? 
            <Icon icon="trash"  size={12} className="p-2 ml-auto" color="#FFFFFF" onClick={ onDelete } />  
            :
            <></>
}
export default TitleEditor